import { Location, locationToString } from '../../common/components/location';

export enum AllowedLocationTypesEnum {
    country = 'country'
}

export const getLocationLabel = (location: Location | null): string => {
    if (!location) return '';
    return location.label && location.label.length ? location.label : locationToString(location) || '';
};
